export const FOUNDER_BADGE = {
  color: "#FFD700",
  bgColor: "rgba(255, 215, 0, 0.12)",
  borderColor: "rgba(255, 215, 0, 0.55)",
  label: "FOUNDER",
};

export const FOUNDER_TOOLTIP_TEXT =
  "One of the first 2,500 members who believed in Ouro from day one and helped build the community in 2026.";
